<select [ngClass]="severity" style="font-weight: bold;" placeholder="Severity" required="true" [(ngModel)]="severity" (ngModelChange)="setSeverity()" name="severity" [disabled]="disabled">
  <option class="CLEARED" value="CLEARED">CLEARED</option>
  <option class="INFO" value="INFO">INFO</option>
  <option class="MINOR" value="MINOR">MINOR</option>
  <option class="WARNING" value="WARNING">WARNING</option>
  <option class="MAJOR" value="MAJOR">MAJOR</option>
  <option class="CRITICAL" value="CRITICAL">CRITICAL</option>
  <option class="INTERMEDIATE" value="INTERMEDIATE">INTERMEDIATE</option>
</select>
